import React from 'react';
import { useSearchkit } from '@searchkit/client';
import { useTranslation } from 'react-i18next';

import {
  Button,
  FormikWrapper,
  FormSelect,
  FormTextField,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const VolunteerWorkSearchBar = () => {
  const api = useSearchkit();
  const { t } = useTranslation();

  const initialValues = {
    title: '',
    province: null,
  };

  const filterProvince = (value) => {
    api.removeFiltersByIdentifier('provinces');

    if (value) {
      api.addFilter({
        identifier: 'provinces',
        value: value,
      });
    }

    api.search();
  };

  const onSubmit = (values) => {
    api.setQuery(values.title);

    if (values.province) {
      filterProvince(values.province);
    }

    api.search();
  };

  const resetOnEmpty = (value) => {
    if (value.target.value === '') {
      api.setQuery('');
      api.search();
    }
  };

  return (
    <div className="VolunteerWorkSearchBar">
      <p className="VolunteerWorkSearchBar__label">Zoek op:</p>
      <FormikWrapper
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        <FormTextField
          fieldName="title"
          placeholder={t('search_placeholder')}
          onChange={resetOnEmpty}
        />
        <FormSelect
          fieldName="province"
          placeholder={t('province')}
          options={{
            drenthe: 'Drenthe',
            flevoland: 'Flevoland',
            friesland: 'Friesland',
            gelderland: 'Gelderland',
            groningen: 'Groningen',
            limburg: 'Limburg',
            brabant: 'Noord-Brabant',
            noord_holland: 'Noord-Holland',
            overijssel: 'Overijssel',
            utrecht: 'Utrecht',
            zeeland: 'Zeeland',
            zuid_holland: 'Zuid-Holland',
          }}
          onChange={filterProvince}
        />
        <Button type="submit">{t('search')} <i className="icon icon-arrow-right icon-variant-4" /></Button>
      </FormikWrapper>
    </div>
  );
};

export default VolunteerWorkSearchBar;
